// router.tsx
import { lazy, Suspense } from 'react';
import { /*Navigate, */Outlet, useRoutes } from 'react-router-dom';
import Questionnaire from '../pages/Questionnaire';
import Home from '../pages/Home';
import { Test1 } from '../test1.tsx';
import Results from "../pages/Results.tsx";     // Import Login component

const Loadable = (Component: React.ElementType) => (props: any) => (
    <Suspense fallback={<div>Loading...</div>}>
        <Component {...props} />
    </Suspense>
);

const NotFound = Loadable(lazy(() => import('../pages/NotFound')));

export default function Router() {
    return useRoutes([
        // Protected Routes
        {
            path: '/',
            element: (
                // <AuthGuard>
                    <Outlet />
                // </AuthGuard>
            ),
            children: [
                { element: <Home />, index: true },
                { path: 'test1', element: <Test1 /> },
                { path: 'questionnaire', element: <Questionnaire /> },
                {path: 'results', element: <Results />},
                // Add more protected routes here
            ],
        },
        // 404 Route
        {
            path: '*',
            element: <NotFound />,
        },
    ]);
}
